import { cn } from '@/shared/utils/utils'
import { ModalWrapper } from './styled'

import './style.scss'

export default function CustomModal(props: any) {
  const { children, className, hiddenScroll } = props

  return (
    <ModalWrapper
      width={1024}
      style={{ top: 120 }}
      {...props}
      className={cn(className)}
      hiddenScroll={hiddenScroll}
      maskTransitionName=""
    >
      {children}
    </ModalWrapper>
  )
}
